import React from "react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// Section des témoignages
const TestimonialsSection = () => {
  return (
    <section className="testimonials">
      <div
        className="background bg-img bg-fixed"
        style={{
          backgroundImage: `url('/img/2.jpg')`,
          height: "50vh",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          padding: 0,
        }}
        data-overlay-dark="3"
      >
        <div className="container">
          <div className="row" style={{ margin: 0 }}>
            <div className="col-md-8 mb-0">
              <h2 data-aos="fade-up">
                Laissez-vous transporter par nos réalisations, où chaque image
                raconte une histoire.
              </h2>
            </div>
            <div className="col-md-4 mb-0">
              <a
                data-aos="fade-up"
                href="/rea"
                className="button-tersiyer2 mt-3"
              >
                Cliquez ici pour en savoir plus !
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

// Section des logos des clients

// Composant principal qui combine les deux sections
const BannerVideo = () => {
  return (
    <div>
      <TestimonialsSection />
    </div>
  );
};

export default BannerVideo;
